// changes longtext to long...
export default (text: string, length: number) => {
  if (text.length > length) {
    return `${text.slice(0, length - 3)}...`;
  }
  return text;
};
